
import { useSelector } from 'react-redux';
import CustomToolTip from '../../CommonComponents/CustomToolTip';
import { BatterySvg, EPSSvg, SolarPanelSvg } from '../Svgs/CatalogSvgs';

const PowerSlider = ({ blankTemplateData, enableBusSlider, selectedComp, setSelectedComp }) => {
    const CloneTemplate = useSelector((state: any) => state.catalog.CloneTemplate);

    const configItems = [
        {
            key: "EPS",
            display: "EPS",
            icon: <EPSSvg />,
            templateKey: "EPS",
            userDataPath: ["assembly", 0, "power", "EPS", "user_data", "numUnits"],
            namePath: ["assembly", 0, "power", "EPS", "atmos-data", "name"],
        },
        {
            key: "Battery",
            display: "Battery",
            icon: <BatterySvg />,
            templateKey: "Battery Pack",
            userDataPath: ["assembly", 0, "power", "Battery Pack", "user_data", "numUnits"],
            namePath: ["assembly", 0, "power", "Battery Pack", "atmos-data", "name"],
        },
        {
            key: "Solar Panel",
            display: "Solar Panel",
            icon: <SolarPanelSvg />,
            templateKey: "Solar Panel",
            userDataPath: ["assembly", 0, "power", "Solar Panel", "user_data", "numUnits"],
            namePath: ["assembly", 0, "power", "Solar Panel", "atmos-data", "name"],
            countKey: "Solar PanelCount", // special case
        },
    ];

    //  Helper: safely get nested value
    const getNested = (obj, path) =>
        path.reduce((acc, key) => (acc ? acc[key] : undefined), obj);

    //  Render a single card
    const renderCard = ({
        key,
        display,
        icon,
        templateKey,
        userDataPath,
        namePath,
        countKey,
    }: {
        key: string;
        display: string;
        icon: JSX.Element;
        templateKey: string;
        userDataPath: (string | number)[];
        namePath: (string | number)[];
        countKey?: string;
    }) => {
        const cloneData = CloneTemplate?.["Power"]?.[templateKey];
        const blankData = getNested(blankTemplateData, namePath);
        const numUnits = countKey && CloneTemplate?.["Power"]?.[countKey]
            ? CloneTemplate?.["Power"]?.[countKey]
            : getNested(blankTemplateData, userDataPath);

        const name = cloneData?.name || blankData;

        return (
            <div
                key={key}
                className={`config-card ${selectedComp === key && "active"}`}
                onClick={() => {
                    setSelectedComp(key);
                    enableBusSlider(
                        cloneData || getNested(blankTemplateData, namePath.slice(0, -1)),
                        templateKey,
                        "Power",
                        numUnits
                    );
                }}
            >
                <h5 className="c-color1">
                    {icon}
                    {display}
                </h5>

                {/* Solar Panel has count display */}
                <div className="d-flex align-items-center gap-2">
                    <div className={`${key === "Solar Panel" ? "w-95" : "w-100"} text-truncate`}>
                        <CustomToolTip title={name} placement="top-start">
                            {name}
                        </CustomToolTip>
                    </div>
                    {(key === "Solar Panel" && name) && `(${numUnits})`}
                </div>
            </div>
        );
    };

    return <div className="config-data-box h-100">{configItems.map(renderCard)}</div>;

};
export default PowerSlider;
